var map = {
	"./dark/status/16forecast/01best.svg": "k74Q",
	"./light/status/16forecast/01best.svg": "HGxy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dnqb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme ^\.\/.*\/status\/16forecast\/01best\.svg$
// module id = dnqb
// module chunks = 0